class BudgetApi {
    getListByCurrentBusiness() {
        return api.call('get', apiUrl + 'budgets/currentBusiness/')
            .then(({ data }) => data);
    }
    get(id) {
        return api.call('get', apiUrl + 'budgets/' + id)
            .then(({ data }) => data);
    }
    create(data) {
        return api.call('post', apiUrl + 'budgets', data)
            .then(({ data }) => data);
    }
    update(data) {
        return api.call('put', apiUrl + 'budgets/' + data.id, data)
            .then(({ data }) => data);
    }
    delete(id) {
        return api.call('delete', apiUrl + 'budgets/' + id)
            .then(({ data }) => data);
    }
}

export default BudgetApi;
